function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "17"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Group_3921",
  "data-name": "Group 3921",
  transform: "translate(-286.5 -909.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2570",
  "data-name": "Path 2570",
  d: "M9.052 5.948a3.1 3.1 0 11-3.1-3.1 3.1 3.1 0 013.1 3.1",
  transform: "translate(289.052 912.051)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_307_-_Outline",
  "data-name": "Path 307 - Outline",
  d: "M8 16.5A8.5 8.5 0 1116.5 8 8.51 8.51 0 018 16.5zM8 1.361A6.639 6.639 0 1014.639 8 6.647 6.647 0 008 1.361z",
  transform: "translate(287 910)"
}))));